import { memo } from 'react';

import { NodeBadgeData } from '../../../../hooks';

import { NodeBadge } from './NodeBadge';

type NodeBadgesProps = {
  addonLeft?: NodeBadgeData;
  addonRight?: NodeBadgeData;
  addonBottom?: NodeBadgeData;
};

export const NodeBadges = memo(({ addonLeft, addonRight, addonBottom }: NodeBadgesProps) => (
  <>
    {addonLeft && <NodeBadge badge={addonLeft} position="left" />}
    {addonRight && <NodeBadge badge={addonRight} position="right" />}
    {addonBottom && <NodeBadge badge={addonBottom} position="bottom" />}
  </>
));

NodeBadges.displayName = 'NodeBadges';
